import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { Globals } from '../../globals/globals';
import { catchError, timeout } from 'rxjs/operators';
import { TeiasoftLoaderService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { UserLogged } from '../../models/data/userLogged.model';
import { UtilsService } from '../utils/utils.service';
import { TeiasoftModalService } from '../teiasoft-bucket/teiasoft-modal.service';

@Injectable()

export class HttpsInterceptor implements HttpsInterceptor {
  constructor(private globals: Globals, private loaderService: TeiasoftLoaderService, private translate: TranslateService,
    private router: Router, private utils: UtilsService, private teiasoftModelService: TeiasoftModalService) { }


  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<unknown> {
    let _token: string = localStorage.getItem("token") == null ? '' : `${localStorage.getItem("token")}`;
    request = request.clone({
      setHeaders: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        "Access-Control-Allow-Origin": "*",
        'accessToken': _token
      },
    });
    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          console.log("[QuoteTool] Error", error);
          this.loaderService.stop();
          let _error: string = '';
          if (error.error instanceof ErrorEvent) {
            /* CLIENT ERRORS */
          } else {
            /* SERVER ERRORS */
            let _errCode: string = error.status.toString();
            let _errorType: string = "";

            /* 0 Unknown Error */
            if (_errCode == '0' && error.statusText == 'Unknown Error') {
              _error = error.message;
            }

            /* 200 */
            if (_errCode == '200') {
              _error = this.translate.instant("errors.200") + " " + error.message;
            }

            /* 400 */
            /* if (_errCode == '400'){
              let _message: string = "";
              if (error.error.error) _message = error.error.error.message;
              if (error.error.message) _message =  error.error.message;
              if (error.error.Message) _message =  error.error.Message;
              _error = this.translate.instant("errors.400") + " " + _message;
            } */

            /* 400 401 403 */
            if (_errCode == '400' || _errCode == '401' || _errCode == '403') {
              // I'VE TO TAKE THE TYPE
              _errorType = (error["error"] && error["error"]["type"] != undefined) ? error["error"]["type"] : '';
              _error = this.translate.instant("errors." + _errCode + _errorType);
            }

            /* 404 */
            if (_errCode == '404') {
              _error = this.translate.instant("errors." + _errCode) + ": " + error.message;
            }

            /* 422 */
            if (_errCode == '422') {
              _error = error.error.detail;
            }

            /* 500 */
            if (_errCode == '500') {
              _error = this.translate.instant("errors." + _errCode +'000')
            }

            /* SHOW ERROR */
            this.teiasoftModelService.show("error", this.translate.instant("commons.error"), _error, '', '', false, undefined, undefined, 'app-global-error');

            if (error.error != undefined && error.error.type === '001' &&
              (error.error.title.toString().toLowerCase() == 'invalid token' || error.error.title.toString().toLowerCase() == 'invalid accesstoken' || error.error.title.toString().toLowerCase() == 'unauthorized')) {
              this.globals.userLogged = new UserLogged();
              this.utils.clearStorage();
              const returnUrl = this.router.url;
              if (returnUrl.startsWith('/login')) {
                this.router.navigate(["/login"]);
              } else {
                this.router.navigate(["/login"], { queryParams: { returnUrl } });
              }
            }
          }
          return throwError(_error);
        })
      )
  }

}
